import {
  MeshBasicMaterial,
  Mesh,
  DoubleSide,
  AlwaysStencilFunc,
  ReplaceStencilOp,
  EqualStencilFunc,
  KeepStencilOp,
  Object3D,
  PlaneGeometry,
  Color,
} from "three";
import { VBase } from "./VBase";
import VUtil from "../VUtils";
import { HorizontalAlignment, VHorizontalLayout } from "../UILayout/VLayout";
import { VSlider2 } from "./_VSlider2";
import { Line2 } from "three/examples/jsm/lines/Line2.js";
import { LineMaterial } from "three/examples/jsm/lines/LineMaterial.js";
import { LineGeometry } from "three/examples/jsm/lines/LineGeometry.js";

const defaultOptions = {
  color: 0x676767,
  opacity: 1,
  sliderColor: 0xffffff,
  handleColor: 0x00ffff,
  sliderOpacity: 1,
  handleOpacity: 1,
  sliderHeight: 0,
  map: null,
  horizontalLayout: new VHorizontalLayout(),
  width: 1.8,
  height: 0.5,
  radius: 0.05,
  sliderExitState: "transparent",
  showSlider: true,
  onHoverEnter: null,
  onHoverExit: null,
  onSliderValueChange: null,
  onElementHoverEnter: null,
  onElementHoverExit: null,
  disabledColor: 0xc8c8c8,
  enabledCb: null,
};

/*
  使用案例

    // 添加元素的函数
      let addMatItem = (scrollview, data) => {
        const container = this.uiLib.createBtn({
          text: "",
          opacity: 0.5,
          color: 0x4f5670,
          width: 0.22,
          height: 0.25,
          radius: 0.02,
        });
        // 添加空函数覆盖默认的放大事件
        container.addHoverEnterEvent(() => {});
        container.addHoverExitEvent(() => {});
        container.addClickEvent((obj) => {
          console.log("选中对象", obj);
        });
        // 为UI对象添加滚动视图的光标进入事件
        container._scrollviewData = data;

        let str = data.name;
        if (!str) str = "";
        if (str.length > 7) {
          str = str.substring(0, 7) + "...";
        }

        const name = this.uiLib.createText({
          text: str,
          textColor: 0xffffff,
          textSize: 0.025,
          align: "left",
          createdCB: (tex) => {
            // 文字对象创建在后面 为UI对象添加滚动视图的光标进入事件
            scrollview._addHoverEnterEventForContent(name);
          },
        });
        name.position.x = -0.09;
        name.position.y = -0.09;
        name.position.z = 0.001;
        container.add(name);

        scrollview.addContent(container);
      };

      const layout = new VHorizontalLayout();
      layout.setBorder(new Vector2(0.05, 0.05));
      layout.setSpacing(0.05);
      layout.setAliment(HorizontalAlignment.Center);
      const scrollview = this.uiLib.createScrollViewHorizontal({
        renderOrder: 99999,
        opacity: 0.5,
        width: 1.0,
        height: 0.5,
        radius: 0,
        horizontalLayout: layout,
        sliderColor: 0xafbbe3,
        handleColor: 0x8993c3,
        sliderOpacity: 0.5,
        handleOpacity: 0.8,
        sliderExitState: "hide",
        sliderHeight: 0.02,
      });
      // 注册光标进入元素事件
      scrollview.addOnElementHoverEnterEvent((item) => {
        console.log("光标进入元素：", item);
      });
      // 注册光标离开元素事件
      scrollview.addOnElementHoverExitEvent((item) => {
        console.log("光标离开元素：", item);
      });
      // 注册滚动区域滚动事件
      scrollview.addOnSliderValueChangeEvent((v) => {
        //console.log("滚动区域发生滚动：" + v);
      });
      this.uiLib.addUIToScene(scrollview);

      const datas = [
        {
          _id: "678a1b7fab9c0a26bca8757e",
          name: "Material-5",
          path: "public/texture/678a1b6cab9c0a26bca87573/Material-5.json",
        },
        {
          _id: "678a1b7fab9c0a26bca8757c",
          name: "Material-4",
          path: "public/texture/678a1b6cab9c0a26bca87573/Material-4.json",
        },
        {
          _id: "678a1b7fab9c0a26bca8757a",
          name: "Material-3",
          path: "public/texture/678a1b6cab9c0a26bca87573/Material-3.json",
        },
        {
          _id: "678a1b7fab9c0a26bca8757",
          name: "Material-5",
          path: "public/texture/678a1b6cab9c0a26bca87573/Material-5.json",
        },
        {
          _id: "678a1b7fab9c0a26bca8757",
          name: "Material-4",
          path: "public/texture/678a1b6cab9c0a26bca87573/Material-4.json",
        },
        {
          _id: "678a1b7fab9c0a26bca8757",
          name: "Material-3",
          path: "public/texture/678a1b6cab9c0a26bca87573/Material-3.json",
        },
      ];
      for (var i = 0; i < datas.length; i++) {
        addMatItem(scrollview, datas[i]);
      }

      // 4 从滚动视图移除指定UI对象
      //scrollview.removeContent(btn2);

      // 5 根据索引索引移除ui对象
      scrollview.removeContentByIndex(1);
    
*/

export class VScrollViewHonrizontal extends VBase {
  /**
   * 水平滚动视图，单行，可以放置大小不同的对象，但对于高度超过滚动视图的会自动缩放为滚动视图高度，从左往右排列，自适应内容宽度
   * options：{
   *    priority: 优先级，默认为1，值越小越靠前
   *    renderOrder: 渲染顺序，默认为99989
   *    color：滚动视图背景色，默认为0x676767
   *    opacity: 滚动视图背景透明度，默认为1，不透明
   *    sliderColor: 滑动条背景色，默认为0xfffff
   *    handleColor: 滑动条handle颜色，默认为0x00ffff
   *    sliderOpacity: 滑动条透明度，默认为1，不透明
   *    handleOpacity: 滑动条handle透明度，默认为1，不透明
   *    sliderHeight：滑动条高度，设置为0将由滚动视图高度决定，默认为0
   *    map：滚动视图背景图片，默认为null，不是地址
   *    horizontalLayout：水平布局参数，是 VHorizontalLayout 类型对象，控制元素的排列和间隙
   *    width：滚动视图宽度，默认为1.8
   *    height：滚动视图高度，默认为0.5
   *    radius: 圆角半径，设为0则是矩形，默认为0.05
   *    showSlider: 是否显示滑动条，设置为false将永远不会显示滑动条，默认为true
   *    sliderExitState: 当光标离开滚动视图后滑动条的状态显示。"normal"-没有变化  "hide"-隐藏  "transparent"-半透明，默认为"transparent"
   *    disabledColor: ui对象禁用颜色，默认为 0xC8C8C8
   * }
   * @param {*} options
   */
  constructor(options, vuiLib) {
    if (!options) options = {};

    const tempOptions = {
      priority: options.priority !== undefined ? options.priority : 1,
      renderOrder:
        options.renderOrder !== undefined ? options.renderOrder : 99989,
      color: options.color !== undefined ? options.color : defaultOptions.color,
      opacity:
        options.opacity !== undefined
          ? options.opacity
          : defaultOptions.opacity,
      sliderColor:
        options.sliderColor !== undefined
          ? options.sliderColor
          : defaultOptions.sliderColor,
      handleColor:
        options.handleColor !== undefined
          ? options.handleColor
          : defaultOptions.handleColor,
      sliderOpacity:
        options.sliderOpacity !== undefined
          ? options.sliderOpacity
          : defaultOptions.sliderOpacity,
      handleOpacity:
        options.handleOpacity !== undefined
          ? options.handleOpacity
          : defaultOptions.handleOpacity,
      sliderHeight:
        options.sliderHeight !== undefined
          ? options.sliderHeight
          : defaultOptions.sliderHeight,
      map: options.map ? options.map : defaultOptions.map,
      showSlider:
        options.showSlider !== undefined
          ? options.showSlider
          : defaultOptions.showSlider,
      horizontalLayout: options.horizontalLayout
        ? options.horizontalLayout
        : defaultOptions.horizontalLayout,
      width: options.width !== undefined ? options.width : defaultOptions.width,
      height:
        options.height !== undefined ? options.height : defaultOptions.height,
      radius:
        options.radius !== undefined ? options.radius : defaultOptions.radius,
      sliderExitState:
        options.sliderExitState !== undefined
          ? options.sliderExitState
          : defaultOptions.sliderExitState,
      disabledColor:
        options.disabledColor !== undefined
          ? options.disabledColor
          : defaultOptions.disabledColor,
      enabledCb: options.enabledCb ? options.enabledCb : null,
    };

    super(tempOptions, vuiLib);

    this._vType = "VScrollViewHonrizontal";

    this.stencilRef = this.vuilib.getStencil();
    this.uiContents = []; // 存储添加到滚动区域的UI对象
    this.needAddUIs = []; // 准备添加到滚动区域的UI对象
    this.needRemoveUIs = [];
    this.needRemoveUIIndexs = [];
    this.interval = null;

    this.name = "VScrollViewHonrizontal";

    this._otherProps = {
      sliderSpeed: 0.02, // 通过按键滑动视图时的速度
      transpanrentSliderOpacity: 0.35, // 半透明状态的滑动条透明度
      sliderColor: tempOptions.sliderColor,
      handleColor: tempOptions.handleColor,
      sliderOpacity: tempOptions.sliderOpacity,
      handleOpacity: tempOptions.handleOpacity,
      sliderHeight: tempOptions.sliderHeight,
      showSlider: tempOptions.showSlider,
      horizontalLayout: tempOptions.horizontalLayout,
      sliderExitState: tempOptions.sliderExitState,
      onSliderValueChange: [],
      onElementHoverEnter: [],
      onElementHoverExit: [],
    };

    // 遮罩区域
    {
      this.viewWidth =
        this._baseProps.width - this._otherProps.horizontalLayout.border.x * 2;
      if (this.viewWidth <= 0) {
        console.warn("滚动视图可视区域错误，请检查horizontalLayout参数");
        this.viewWidth = this._baseProps.width;
      }
      this.viewHeight =
        this._baseProps.height - this._otherProps.horizontalLayout.border.y * 2;
      if (this.viewHeight <= 0) {
        console.warn("滚动视图可视区域错误，请检查horizontalLayout参数");
        this.viewHeight = this._baseProps.height;
      }
      let geo = VUtil.createRectangleGeometry(
        this.viewWidth,
        this.viewHeight,
        this._baseProps.radius
      );
      let maskMat = new MeshBasicMaterial({
        color: 0xff0000,
        //side: DoubleSide,
        stencilWrite: true, // 启用模板写入
        stencilRef: this.stencilRef, // 模板参考值
        stencilFunc: AlwaysStencilFunc, // 总是通过模板测试
        stencilZPass: ReplaceStencilOp, // 通过深度测试时，将模板值替换为参考值
        transparent: true,
        opacity: 0.01, //0.01,
        depthTest: false,
        depthWrite: false,
        colorWrite: false,
        stencilFuncMask: 0xff, // 使用全8位掩码
        stencilFail: ReplaceStencilOp, // 新增
        stencilZFail: ReplaceStencilOp, // 新增
      });
      VUtil.convertSRGBToLinear(maskMat);

      this.viewArea = new Mesh(geo, maskMat);
      this.viewArea.renderOrder = this._baseProps.renderOrder;
      this.add(this.viewArea);
    }

    // 内容区域
    this.content = new Object3D();
    this.viewArea.add(this.content);
    this.content.position.x = -this.viewWidth / 2;
    this.contentWidth = 0; // 当前滚动视图内容总宽度

    // 滑动条
    {
      let sliderHeight = 0;
      if (this._otherProps.sliderHeight !== 0) {
        sliderHeight = this._otherProps.sliderHeight;
      } else {
        sliderHeight = this._baseProps.width / 10;
        if (sliderHeight < 0.025) sliderHeight = 0.025;
        if (sliderHeight > 0.05) sliderHeight = 0.05;
      }

      this.slider = new VSlider2({
        color: this._otherProps.sliderColor,
        handleColor: this._otherProps.handleColor,
        width: this._baseProps.width,
        opacity: this._otherProps.sliderOpacity,
        handleOpacity: this._otherProps.handleOpacity,
        height: sliderHeight,
        radius: sliderHeight / 2,
      });
      this.slider.setProgressValue(0);

      if (!this._otherProps.showSlider) {
        this.slider.material.visible = false;
        this.slider.handle.material.visible = false;
        this.slider._dontCheckEcsy = true;
        this.slider.handle._dontCheckEcsy = true;
      }

      this.add(this.slider);
      this.slider.position.y = -this._baseProps.height / 2 + sliderHeight / 2;
      this.slider.position.z = 0.004;

      this.slider.visible = false;
      this.slider.material.transparent = true;
      this.slider.handle.material.transparent = true;
      if (this._otherProps.sliderExitState === "transparent") {
        this.slider.material.opacity =
          this._otherProps.transpanrentSliderOpacity;
        this.slider.handle.material.opacity =
          this._otherProps.transpanrentSliderOpacity;
      }

      this.slider.addOnValueChangeEvent((v) => {
        this._sliderValueChanged(v);
      });

      this.slider.addHoverEnterEvent(() => {
        this.onHoverEnter();
      });
      this.slider.addHoverExitEvent(() => {
        this.onHoverExit();
      });
      this.slider.addHandlerHoverEnterEvent(() => {
        this.onHoverEnter();
      });
      this.slider.addHandlerHoverExitEvent(() => {
        this.onHoverExit();
      });
    }

    if (this.vuilib) {
      this.vuilib.addComponents(this.slider.handle, this._priority + 1);
    }

    this.width = this._baseProps.width;
    this.height = this._baseProps.height;
  }

  clear() {
    this.slider.clear();

    this._clearBorder();
    super.clear();
  }

  /**
   * 滑动条变化时的回调
   * @param {*} v
   */
  _sliderValueChanged(v) {
    if (this.contentWidth > this.viewWidth) {
      this.content.position.x =
        -this.viewWidth / 2 - v * (this.contentWidth - this.viewWidth);

      for (var i = 0; i < this._otherProps.onSliderValueChange.length; i++) {
        this._otherProps.onSliderValueChange[i](v);
      }
    }
  }

  /**
   * 设置滑动条数值
   */
  setSliderValue(v) {
    if (!this._baseProps.enabled) return;
    this.slider.setProgressValue(v);
  }

  /**
   * 添加UI对象到滚动视图
   * 目标是支持所有的UI类型（VButton、VText、VContainer、VLider）且支持滚动视图嵌套，深层次交互。
   * 暂时不支持深层次交互
   * @param {Mesh} uiContent 由VUILib创建的ui对象
   * @param {Int} index 索引，添加到指定索引位置上。默认为-1，添加到最后面
   */
  addContent(uiContent, index = -1) {
    // 文字内容可能暂时还没有获取到宽度和高度，添加到数组中循环检测等待获取到宽度
    if (
      (uiContent._vType === "VText" && uiContent.height === 0) ||
      this.needAddUIs.length > 0
    ) {
      uiContent._scrollViewIndex = index;
      this.needAddUIs.push(uiContent);
      if (!this.interval) {
        this.interval = setInterval(() => {
          this._checkNeedAddContent();
        }, 50);
      }
    } else {
      this._addContent(uiContent, index);
    }
  }

  /**
   * 从滚动视图移除一个ui对象
   * @param {*} uiContent
   */
  removeContent(uiContent) {
    if (this.interval !== null) {
      this.needRemoveUIs.push(uiContent);
    } else {
      this._removeContent(uiContent);
    }
  }

  /**
   * 移除滚动视图内所有UI对象
   */
  clearContent() {
    if (this.interval !== null) {
      for (var i = 0; i < this.uiContents.length; i++) {
        this.needRemoveUIs.push(this.uiContents[i]);
      }
    } else {
      while (this.uiContents.length > 0) {
        this._removeContent(this.uiContents[0]);
      }
    }
  }

  /**
   * 根据索引从滚动视图移除一个ui对象
   * @param {*} index
   */
  removeContentByIndex(index) {
    if (this.interval !== null) {
      this.needRemoveUIIndexs.push(index);
    } else {
      this._removeContentByIndex(index);
    }
  }

  /**
   * 用于循环检测是否还有待添加到滚动视图的对象 内部使用
   */
  _checkNeedAddContent() {
    if (this.needAddUIs.length > 0) {
      if (this.needAddUIs[0].width !== 0 || this.needAddUIs[0].height !== 0) {
        let index = this.needAddUIs[0]._scrollViewIndex;
        delete this.needAddUIs[0]._scrollViewIndex;
        this._addContent(this.needAddUIs[0], index);
        this.needAddUIs.splice(0, 1);
      }
    }

    if (this.needAddUIs.length <= 0) {
      clearInterval(this.interval);
      this.interval = null;

      if (this.needRemoveUIs.length > 0) {
        for (var i = 0; i < this.needRemoveUIs.length; i++) {
          this._removeContent(this.needRemoveUIs[i]);
        }
        this.needRemoveUIs = [];
      }
      if (this.needRemoveUIIndexs.length > 0) {
        for (var j = 0; j < this.needRemoveUIIndexs.length; j++) {
          this._removeContentByIndex(this.needRemoveUIIndexs[j]);
        }
        this.needRemoveUIIndexs = [];
      }
    }
  }

  /**
   * 为UI对象添加滚动视图的光标进入事件，让UI对象也可以光标进入时显示滑动条
   * @param {*} uiContent
   */
  _addHoverEnterEventForContent(uiContent) {
    if (uiContent._vType) {
      uiContent.addHoverEnterEvent(() => {
        this.onHoverEnter();
      });
    }
  }

  /**
   * 为UI对象添加滚动视图的光标离开事件，让UI对象也可以光标离开时隐藏滑动条
   * @param {*} uiContent
   */
  _addHoverExitEventForContent(uiContent) {
    if (uiContent._vType) {
      uiContent.addHoverExitEvent(() => {
        this.onHoverExit();
      });
    }
  }

  /**
   * 为UI对象添加检测是否可选中，在滚动视图中，对于区域外的ui（被模板测试剔除了，无法看见）不能被选中
   * @param {*} uiContent
   */
  _addCheckSelectableEventForContent(uiContent) {
    if (uiContent._vType) {
      uiContent.addCheckSelectableEvent((worldPos) => {
        return this.checkSelectable(worldPos);
      });
    }
  }

  /**
   * 设置材质的模板值，如果添加的元素内部有VText类型，则需要在添加到滚动视图后再设置
   * 包括后面对元素进行修改后也需要重新设置
   * @param {*} mat
   */
  _setMatStancil(mat) {
    const mats = Array.isArray(mat) ? mat : [mat];
    for (var i = 0; i < mats.length; i++) {
      mats[i].stencilWrite = true;
      mats[i].stencilRef = this.stencilRef;
      mats[i].stencilFunc = EqualStencilFunc;
      mats[i].stencilZFail = KeepStencilOp;
      mats[i].transparent = true;
      mats[i].stencilFuncMask = 0xff; // 使用全8位掩码
      //mats[i].stencilFail = KeepStencilOp; // 新增 高版本（171）不能加这个
    }
  }

  /**
   * 为添加到滚动视图才后创建的ui子对象添加一些设置（主要针对文字）
   * @param {*} uiContent
   */
  setSomethingForLater(uiContent) {
    uiContent.traverse((node) => {
      node.renderOrder += this._baseProps.renderOrder;
      if (node.material) {
        this._setMatStancil(node.material);
      }
    });
    this._addCheckSelectableEventForContent(uiContent);
    this._addHoverEnterEventForContent(uiContent);
    this._addHoverExitEventForContent(uiContent);
  }

  /**
   * 内部使用
   * @param {*} uiContent
   * @param {*} index
   */
  _addContent(uiContent, index = -1) {
    // 设置事件
    uiContent.addHoverEnterEvent((target) => {
      this._onElementHoverEnter(target);
    });
    uiContent.addHoverExitEvent((target) => {
      this._onElementHoverExit(target);
    });
    uiContent.addCheckSelectableEvent((worldPos) => {
      return this.checkSelectable(worldPos);
    });

    // 设置ui对象的模板
    uiContent.traverse((node) => {
      node.renderOrder += this._baseProps.renderOrder;
      if (node.material) {
        this._setMatStancil(node.material);
      }
    });

    // 过高，进行缩放
    if (uiContent.height > this.viewHeight) {
      let r = this.viewHeight / uiContent.height;
      uiContent.scale.multiplyScalar(r);
      uiContent.height = this.viewHeight;
      uiContent.width *= r;
    }

    // 插入
    if (index > -1 && index < this.uiContents.length) {
      this.content.add(uiContent);
      uiContent.position.x =
        this.uiContents[index].position.x -
        this.uiContents[index].width / 2 +
        uiContent.width / 2;

      // 将后面的往后移
      for (var i = index; i < this.uiContents.length; i++) {
        this.uiContents[i].position.x +=
          this._otherProps.horizontalLayout.spacing + uiContent.width;
      }

      this.uiContents.splice(index, 0, uiContent);

      this.contentWidth +=
        this._otherProps.horizontalLayout.spacing + uiContent.width;
    }
    // 放到最后面
    else {
      this.uiContents.push(uiContent);

      this.content.add(uiContent);
      if (this.uiContents.length > 1) {
        uiContent.position.x =
          this.contentWidth +
          this._otherProps.horizontalLayout.spacing +
          uiContent.width / 2;
        this.contentWidth +=
          this._otherProps.horizontalLayout.spacing + uiContent.width;
      } else {
        uiContent.position.x = uiContent.width / 2;
        this.contentWidth = uiContent.width;
      }
    }

    // 设置上中下排列
    if (this.viewHeight - uiContent.height > 0.001) {
      switch (this._otherProps.horizontalLayout.alignment) {
        case HorizontalAlignment.Upper:
          uiContent.position.y = this.viewHeight / 2 - uiContent.height / 2;
          break;
        case HorizontalAlignment.Center:
          break;
        case HorizontalAlignment.Lower:
          uiContent.position.y = -this.viewHeight / 2 + uiContent.height / 2;
          break;
      }
    }

    uiContent.position.z += 0.0001;

    if (this.border && this.curHoverElement) {
      this.border.position.copy(this.curHoverElement.position);
      this.border.position.z += 0.001;
    }

    if (this.hoverEntering) {
      if (
        (this._otherProps.sliderExitState === "normal" ||
          this._otherProps.sliderExitState === "transparent") &&
        this.contentWidth > this.viewWidth
      ) {
        this.slider.visible = true;
      }
    }
  }

  /**
   * 内部使用
   * @param {*} uiContent
   */
  _removeContent(uiContent) {
    this.vuilib.removeUI(uiContent);
    let index = this.uiContents.indexOf(uiContent);
    if (index >= 0) {
      this.uiContents.splice(index, 1);

      // if (this.border)
      //   this.border.position.x -=
      //     uiContent.width + this._otherProps.horizontalLayout.spacing;

      for (var i = index; i < this.uiContents.length; i++) {
        this.uiContents[i].position.x -=
          uiContent.width + this._otherProps.horizontalLayout.spacing;
      }

      this.contentWidth -= uiContent.width;
      this.contentWidth -= this._otherProps.horizontalLayout.spacing;

      if (this.hoverEntering) {
        if (
          (this._otherProps.sliderExitState === "normal" ||
            this._otherProps.sliderExitState === "transparent") &&
          this.contentWidth < this.viewWidth
        ) {
          this.slider.visible = false;
        }
      }

      uiContent.clear();

      if (this.border && this.curHoverElement) {
        this.border.position.copy(this.curHoverElement.position);
        this.border.position.z += 0.001;
      }
    }
  }

  /**
   * 内部使用
   * @param {*} index
   */
  _removeContentByIndex(index) {
    if (index >= 0 && index < this.uiContents.length) {
      this.removeContent(this.uiContents[index]);
    }
  }

  _onLeftBtnEvent(value) {
    if (!this._baseProps.enabled) return;
    if (this.slider.value <= 0) return;

    const speed = Math.abs(value) * this._otherProps.sliderSpeed;

    if (this.slider.value - speed >= 0) {
      this.slider.setProgressValue(this.slider.value - speed);
    } else {
      this.slider.setProgressValue(0);
    }
  }

  _onRightBtnEvent(value) {
    if (!this._baseProps.enabled) return;
    if (this.slider.value >= 1) return;

    const speed = Math.abs(value) * this._otherProps.sliderSpeed;

    if (this.slider.value + speed <= 1) {
      this.slider.setProgressValue(this.slider.value + speed);
    } else {
      this.slider.setProgressValue(1);
    }
  }

  /**
   * 光标进入滚动视图
   */
  onHoverEnter() {
    if (!this._baseProps.enabled) return;
    this.vuilib.onLeftBtnEvent = (value) => {
      this._onLeftBtnEvent(value);
    };
    this.vuilib.onRightBtnEvent = (value) => {
      this._onRightBtnEvent(value);
    };

    // 设置滑动条显示隐藏
    switch (this._otherProps.sliderExitState) {
      case "normal": {
        break;
      }
      case "hide": {
        if (this.contentWidth > this.viewWidth) {
          this.slider.visible = true;
        }
        break;
      }
      case "transparent": {
        this.slider.material.opacity = 1;
        this.slider.handle.material.opacity = 1;
        break;
      }
    }
    this.hoverEntering = true;

    super.onHoverEnter();
  }

  /**
   * 光标离开滚动视图
   */
  onHoverExit() {
    this.hoverEntering = false;
    //if (!this._baseProps || !this._baseProps.enabled) return;
    this.vuilib.onLeftBtnEvent = null;
    this.vuilib.onRightBtnEvent = null;

    if (this._otherProps) {
      // 设置滑动条显示隐藏
      switch (this._otherProps.sliderExitState) {
        case "normal": {
          break;
        }
        case "hide": {
          this.slider.visible = false;
          break;
        }
        case "transparent": {
          this.slider.material.opacity =
            this._otherProps.transpanrentSliderOpacity;
          this.slider.handle.material.opacity =
            this._otherProps.transpanrentSliderOpacity;
          break;
        }
      }
    }

    super.onHoverExit();
  }

  /**
   * 光标进入元素事件
   * @param {*} target
   */
  _onElementHoverEnter(target) {
    if (!this._baseProps.enabled) return;
    this.curHoverElement = target;

    if (this._otherProps.onElementHoverEnter.length > 0) {
      for (var i = 0; i < this._otherProps.onElementHoverEnter.length; i++)
        this._otherProps.onElementHoverEnter[i](target);
    } else {
      this.border = this._createBorder(target.width, target.height);
      this.content.add(this.border);
      this.border.position.copy(target.position);
      this.border.position.z += 0.001;
    }

    this.onHoverEnter();
  }

  /**
   * 光标离开元素事件
   * @param {*} target
   */
  _onElementHoverExit(target) {
    if (!this._baseProps.enabled) return;
    this.curHoverElement = null;
    if (this._otherProps.onElementHoverExit.length > 0) {
      for (var i = 0; i < this._otherProps.onElementHoverExit.length; i++)
        this._otherProps.onElementHoverExit[i](target);
    }
    this._clearBorder();

    this.onHoverExit();
  }

  /**
   * 重写基类的检测是否可选中事件
   * @param {*} worldPos
   * @returns
   */
  checkSelectable(worldPos) {
    if (!this._baseProps.enabled) return false;

    const localPos = this.worldToLocal(worldPos);

    if (isNaN(localPos.x)) return false;

    if (Math.abs(localPos.x) > this.viewWidth / 2) return false;

    return true;
  }

  getClickable() {
    if (!this.visible || !this._baseProps.enabled) return [];
    const res = [];
    if (this._otherProps.showSlider) {
      if (this.slider.visible) {
        res.push(this.slider.handle);
      }
    }
    return res;
  }

  /**
   * 创建光标悬停元素时高亮边框
   * @param {*} width
   * @param {*} height
   * @returns
   */
  _createBorder(width, height) {
    this._clearBorder();
    let points = [
      -width / 2,
      height / 2,
      0,

      width / 2,
      height / 2,
      0,

      width / 2,
      -height / 2,
      0,

      -width / 2,
      -height / 2,
      0,

      -width / 2,
      height / 2,
      0,
    ];

    let color = new Color(0xff6d33);
    let colors = [
      color.r,
      color.g,
      color.b,

      color.r,
      color.g,
      color.b,

      color.r,
      color.g,
      color.b,

      color.r,
      color.g,
      color.b,

      color.r,
      color.g,
      color.b,
    ];

    const geometry = new LineGeometry();
    geometry.setPositions(points);
    geometry.setColors(colors);
    const matLine = new LineMaterial({
      color: 0xffffff,
      linewidth: 0.002, // in world units with size attenuation, pixels otherwise
      vertexColors: true,
      dashed: false,
      alphaToCoverage: true,
      transparent: true,

      stencilWrite: true, // 启用模板写入
      stencilRef: this.stencilRef, // 模板参考值
      stencilFunc: EqualStencilFunc, // 只渲染模板值等于参考值的区域
      stencilZFail: KeepStencilOp, // 深度测试失败时保持模板值
      stencilFuncMask: 0xff, // 使用全8位掩码
      stencilFail: KeepStencilOp, // 新增
    });

    const line = new Line2(geometry, matLine);
    //line.computeLineDistances();
    line.renderOrder = this._baseProps.renderOrder + 1;
    return line;
  }

  _clearBorder() {
    if (this.border) {
      this.border.geometry.dispose();
      this.border.material.dispose();
      this.border.removeFromParent();
      this.border = null;
    }
  }

  /**
   * 添加滑动条值改变回调事件，回调参数为当前滑动条的值
   * @param {*} fun
   * @returns
   */
  addOnSliderValueChangeEvent(fun) {
    if (!fun) return;
    this._otherProps.onSliderValueChange.push(fun);
  }

  /**
   * 移除一个 滑动条值改变回调事件
   * @param {*} fun
   * @returns
   */
  removeOnSliderValueChangeEvent(fun) {
    if (!fun) return;
    let index = this._otherProps.onSliderValueChange.indexOf(fun);
    if (index >= 0) {
      this._otherProps.onSliderValueChange.splice(index, 1);
    }
  }

  /**
   * 移除所有 滑动条值改变回调事件
   * @returns
   */
  removeAllOnSliderValueChangeEvent() {
    this._otherProps.onSliderValueChange = [];
  }

  /**
   * 增加一个 光标进入滚动视图元素事件回调，回调参数为当前进入的元素对象
   * @param {*} value
   */
  addOnElementHoverEnterEvent(fun) {
    if (!fun) return;
    this._otherProps.onElementHoverEnter.push(fun);
  }

  /**
   * 移除一个 光标进入滚动视图元素事件回调
   * @param {*} fun
   */
  removeOnElementHoverEnterEvent(fun) {
    if (!fun) return;
    let index = this._otherProps.onElementHoverEnter.indexOf(fun);
    if (index >= 0) {
      this._otherProps.onElementHoverEnter.splice(index, 1);
    }
  }

  /**
   * 移除所有 光标进入滚动视图元素事件回调
   */
  removeAllOnElementHoverEnterEvent() {
    this._otherProps.onElementHoverEnter = [];
  }

  /**
   * 增加一个 光标离开滚动视图元素事件回调，回调参数为当前离开的元素对象
   * @param {*} fun
   */
  addOnElementHoverExitEvent(fun) {
    if (!fun) return;
    this._otherProps.onElementHoverExit.push(fun);
  }

  /**
   * 移除一个 光标离开滚动视图元素事件回调
   * @param {*} fun
   */
  removeOnElementHoverExitEvent(fun) {
    if (!fun) return;
    let index = this._otherProps.onElementHoverExit.indexOf(fun);
    if (index >= 0) {
      this._otherProps.onElementHoverExit.splice(index, 1);
    }
  }

  /**
   * 移除所有 光标离开滚动视图元素事件回调
   */
  removeAllOnElementHoverExitEvent() {
    this._otherProps.onElementHoverExit = [];
  }
}
